import { useFormContext } from 'react-hook-form';
import { useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faKey } from '@fortawesome/pro-light-svg-icons';

import { loginSso } from '../../../../api/auth/auth.api';
import { setIsDeviceRemembered } from '../../../../utils/next/auth.utils';
import { withFormController } from '../../../hocs/forms';
import { LoginFormType, LoginFormValues } from '../types';
import { StyledLink, StyledLoginButton } from './helpers';
import {
  Checkbox as CheckboxBase,
  FormControlLabel,
  Typography,
} from '@mui/material';
import { Box } from '@mui/system';

const Checkbox = withFormController(CheckboxBase);

const SsoForm = () => {
  const methods = useFormContext<LoginFormValues>();
  const location = useLocation<{ redirectUrl?: string; from?: Location }>();
  const [username, rememberDevice] = methods.watch([
    'username',
    'rememberDevice',
  ]);

  const handleSsoLogin = async () => {
    const isValid = await methods.trigger();

    if (!isValid) {
      return;
    }

    const originalPath =
      location.state?.redirectUrl ??
      location.state?.from?.pathname +
        location.state?.from?.search +
        location.state?.from?.hash;
    const redirectPath = originalPath || null;

    if (redirectPath) {
      sessionStorage.setItem('postLoginRedirectPath', redirectPath);
    } else {
      sessionStorage.removeItem('postLoginRedirectPath');
    }
    sessionStorage.setItem('ssoCallbackPath', '/loading');
    setIsDeviceRemembered(rememberDevice);
    loginSso(username);
  };

  return (
    <>
      <FormControlLabel
        control={
          <Checkbox
            name="rememberDevice"
            defaultChecked={methods.getValues('rememberDevice')}
            color="secondary"
          />
        }
        label={
          <Typography variant="caption" style={{ color: '#fff' }}>
            Remember this device
          </Typography>
        }
      />

      <StyledLoginButton
        size="large"
        disableRipple
        fullWidth
        onClick={handleSsoLogin}
        disabled={!username.trim()}
        sx={{
          gap: 1,
          mb: 6,
        }}
      >
        <FontAwesomeIcon icon={faKey} />
        Continue with SSO
      </StyledLoginButton>

      <Box mt={6} display="flex" alignItems="center" gap={2}>
        <StyledLink
          onClick={() => {
            methods.setValue('sso.loginFormType', LoginFormType.EMAIL);
          }}
        >
          Login with Password
        </StyledLink>
      </Box>
    </>
  );
};

export default SsoForm;
